export default __webpack_public_path__ + "static/media/google-store-badge.43d62c37.png";